/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  height: {
    type: String,
    "default": ""
  }
};

export { props as default };
//# sourceMappingURL=header-props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/layout/header-props.js
// module id = null
// module chunks = 